<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col
        :span="4"
        class="cs-main-left-container"
      >
        <navigator></navigator>
      </el-col>
      <el-col
        :span="20"
        class="backgroud-gray cs-fullHeight cs-main-right-container"
      >
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <span class="cs-title">作业详情</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/homeworkManage' }">作业管理</el-breadcrumb-item>
                    <el-breadcrumb-item v-if="studentHomeworkData.CourseType == 1" :to="{ path: '/homeworkManage' }">大学补习</el-breadcrumb-item>
                    <el-breadcrumb-item v-if="studentHomeworkData.CourseType == 2" :to="{ path: '/homeworkManage' }">应试英语</el-breadcrumb-item>
                    <el-breadcrumb-item v-if="studentHomeworkData.CourseType == 3" :to="{ path: '/homeworkManage' }">职业培训</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: `/homeworkList?courseType=${studentHomeworkData.CourseType}&courseId=${studentHomeworkData.CourseId}&campusId=${studentHomeworkData.CampusId}&courseName=${studentHomeworkData.CourseName}` }">{{studentHomeworkData.CourseName}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{studentHomeworkData.HomeworkName}}</el-breadcrumb-item>
                </el-breadcrumb>
              </el-col>
            </el-row>
            <el-row v-loading="isLoading">
              <el-col>
                <el-row class="cs-studentHomeworkDetail-top">
                  <el-col :span="12">
                    <homeworkBasicInfor :canEdit="false" :showStatus="true" :data="homeworkBasicInforData"></homeworkBasicInfor>
                  </el-col>
                  <el-col :span="12">
                    <homeworkFiles :data="homeworkFilesData"></homeworkFiles>
                  </el-col>
                </el-row>
                <el-row  class="cs-studentHomeworkDetail-bottom">
                  <el-col>
                    <studentHomeworkFileList :data="studentHomeworkFileListData" @fileChange="onFileChange"></studentHomeworkFileList>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.cs-studentHomeworkDetail-top{
  margin-top:20px;
}
.cs-studentHomeworkDetail-bottom{
margin-top:20px;
}
</style>

<script>
import navigator from "../../components/navigator";
import studentHomeworkFileList from "../../components/homework/studentHomeworkFileList";
import homeworkBasicInfor from "../../components/homework/homeworkBasicInfor";
import homeworkFiles from "../../components/homework/homeworkFiles";
import {getStudentHomework} from "../../service/homework.service";

export default {
  data() {
    return {
      isLoading: false,
      studentHomeworkId: 0,
      studentHomeworkData:{},
      homeworkBasicInforData:{},
      homeworkFilesData:{},
      studentHomeworkFileListData:{}
    };
  },
  components: {
    navigator,
    studentHomeworkFileList,
    homeworkBasicInfor,
    homeworkFiles
  },
  computed: {},
  created() {
    this.studentHomeworkId = Number(this.$route.query.studentHomeworkId);
    this.homeworkId = Number(this.$route.query.homeworkId);
    this.init();
  },
  methods: {
    init(){
      if (!this.homeworkId && !this.studentHomeworkId){
        return;
      }
      this.getStudentHomeworkData();
    },
    getComponentData(isBasicInfo){
      if (!this.studentHomeworkData){
        return;
      }

      this.homeworkBasicInforData = {
        courseId: this.studentHomeworkData.CourseId,
        homeworkId: this.studentHomeworkData.CourseHomeworkId,
        campusId: this.studentHomeworkData.CampusId,
        homeworkStatus: this.studentHomeworkData.HomeworkStatus,
        homeworkStatusText: this.studentHomeworkData.HomeworkStatusText
      };
      
      if (!isBasicInfo){
        this.homeworkFilesData ={
          homeworkId: this.studentHomeworkData.CourseHomeworkId,
        };

        this.studentHomeworkFileListData = {
          studentHomeworkId: this.studentHomeworkData.StudentHomeworkId,
          isEnd: this.studentHomeworkData.IsEnd,
          isCompleted: this.studentHomeworkData.IsCompleted
        };
      }
    },
    getStudentHomeworkData(){
      this.isLoading = true;
      getStudentHomework(this.homeworkId,this.studentHomeworkId).then(result =>{
        if (result && result.success){
          this.studentHomeworkData = result.data;
          this.getComponentData();
        }else{
          if (!!result.message){
            this.$message.error(result.message);
          }
        }
        this.isLoading = false;
      }).catch(()=>{
        this.isLoading = false;
      });
    },
    onFileChange(){
      this.getStudentHomeworkData();
    }
  },
  watch: {

  }
};
</script>



// WEBPACK FOOTER //
// src/page/homework/studentHomeworkDetail.vue